import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M14.586 8H8V6h10v10h-2V9.414l-8.293 8.293-1.414-1.414L14.586 8z" }));
export default createSvgIcon(iconPath, "LinkArrow");
//# sourceMappingURL=LinkArrowIcon.js.map